import { render, staticRenderFns } from "./AppliedPmtaConfigForm.vue?vue&type=template&id=076f0219&scoped=true"
import script from "./AppliedPmtaConfigForm.vue?vue&type=script&lang=js"
export * from "./AppliedPmtaConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f0219",
  null
  
)

export default component.exports